<template>
  <el-dialog
    :title="id ? '编辑压差报警设置' : '新增压差报警设置'"
    :visible.sync="dialogVisible"
    width="616px"
    class="custom-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @open="openFn"
    @close="closeFn"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="130px">
      <el-form-item label="工厂" prop="factoryId">
        <el-select v-model="formData.factoryId" filterable @change="factoryChange" placeholder="请选择工厂">
          <el-option v-for="item in factoryOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="车间" prop="workshopId">
        <el-select v-model="formData.workshopId" filterable @change="workShopChange" placeholder="请选择车间">
          <el-option v-for="item in workshopOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="正压场景" prop="positiveSceneId">
        <el-select v-model="formData.positiveSceneId" filterable placeholder="请选择正压场景">
          <el-option v-for="item in sceneOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="临近低压对照场景" prop="negativeSceneId">
        <el-select v-model="formData.negativeSceneId" filterable placeholder="请选择临近低压对照场景">
          <el-option v-for="item in sceneOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="输入压差预警值" prop="pressureDiffAlert">
        <el-input-number
          v-model="formData.pressureDiffAlert"
          placeholder="请输入压差预警值"
          :min="1"
          :max="10"
          :step="0.1"
          controls-position="right"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="报警推送联系人" prop="contactUserIdList">
        <el-select
          v-model="formData.contactUserIdList"
          filterable
          multiple
          collapse-tags
          placeholder="请选择报警推送联系人"
        >
          <el-option v-for="item in pushPersonList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="报警设置时间" prop="pushTimeRange">
        <div v-for="(item, index) in formData.pushTimeRange" :key="`index${index}`" class="range-time-box">
          <el-time-picker
            :key="`range${index}`"
            is-range
            v-model="item[`pushTime${index + 1}`]"
            value-format="HH:mm"
            format="HH:mm"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
          >
          </el-time-picker>
          <i
            :class="['el-icon-delete', index === 0 ? 'fist-time-picker-del-but' : '']"
            @click="delPushTimeRange(item, index)"
          ></i>
        </div>

        <!-- 添加报警设置时间 -->
        <div class="add-content-box">
          <i class="el-icon-circle-plus-outline" @click="addPushTimeRange"></i>
          <span>添加报警设置时间</span>
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button v-hasPermi="['enterpr:pressdifalarm:save']" type="primary" @click="subMit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '@/utils/request';
import api from '@/utils/api';
import { bottom } from '@antv/x6/lib/registry/port-layout/line';
import workshop from '@/store/modules/workshop';
export default {
  data() {
    return {
      formData: {
        factoryId: '',
        workshopId: '',
        positiveSceneId: '',
        negativeSceneId: '',
        pressureDiffAlert: '',
        contactUserIdList: [],
        pushTimeRange: [
          {
            pushTime1: ['00:00', '23:59']
          }
        ]
      },
      rules: {
        factoryId: [{ required: true, message: '请选择工厂', trigger: ['blur', 'change'] }],
        workshopId: [{ required: true, message: '请选择车间', trigger: ['blur', 'change'] }],
        positiveSceneId: [
          { required: true, message: '请选择正压场景', trigger: ['blur', 'change'] },
          { validator: this.valiDatorScene, trigger: ['blur', 'change'] }
        ],
        negativeSceneId: [
          { required: true, message: '请选择负压场景', trigger: ['blur', 'change'] },
          { validator: this.valiDatorScene, trigger: ['blur', 'change'] }
        ],
        pressureDiffAlert: [{ required: true, message: '请输入压差预警值', trigger: ['blur', 'change'] }],
        contactUserIdList: [{ required: true, message: '请选择报警推送联系人', trigger: ['blur', 'change'] }],
        pushTimeRange: [{ required: true, message: '请选择报警设置时间', trigger: ['blur', 'change'] }]
      },
      //工厂数据
      factoryOptions: [],
      // 车间数据
      workshopOptions: [],
      sceneOptions: [],
      dialogVisible: false,
      pushPersonList: [],
      revision: ''
    };
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  methods: {
    valiDatorScene(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    },
    openFn() {
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
      if (this.id) {
        this.getDetail();
      }
    },
    closeFn() {
      this.formData = {
        factoryId: '',
        workshopId: '',
        positiveSceneId: '',
        negativeSceneId: '',
        pressureDiffAlert: '',
        contactUserIdList: [],
        pushTimeRange: [
          {
            pushTime1: ['00:00', '23:59']
          }
        ]
      };
      this.revision = '';
      this.$refs.form.clearValidate();
    },
    initData() {
      this.getFactoryByCustomer();
      this.getPushPersonList();
    },
    // 根据客户查询工厂
    getFactoryByCustomer() {
      this.$store
        .dispatch('workshop/getFactoryByCustomer')
        .then((result) => {
          if (result.code === 200 && result.data.length) {
            this.factoryOptions = result.data;
          } else {
            this.factoryOptions = [];
          }
        })
        .catch((err) => {
          this.factoryOptions = [];
        });
    },
    // 根据工厂查询车间
    getWorkshopByFactory() {
      this.$store
        .dispatch('scene/getWorkshopByFactory', { factoryId: this.formData.factoryId })
        .then((result) => {
          if (result.code === 200 && result.data && result.data.length > 0) {
            this.workshopOptions = result.data;
          } else {
            this.workshopOptions = [];
          }
        })
        .catch((err) => {
          this.workshopOptions = [];
        });
    },
    // 根据车间查询场景
    getSceneByWorkshop() {
      this.$store
        .dispatch('monitorData/getSceneByWorkshop', { workshopId: this.formData.workshopId })
        .then((result) => {
          if (result.code === 200 && result.data && result.data.length > 0) {
            this.sceneOptions = result.data;
          } else {
            this.sceneOptions = [];
          }
        })
        .catch((err) => {
          this.sceneOptions = [];
        });
    },
    /** 查询推送联系人 */
    getPushPersonList() {
      request
        .get(`${api.alarmManagement.getUseDropDownList}`)
        .then((res) => {
          if (res.code === 200) {
            this.pushPersonList = res.data || [];
          } else {
            this.pushPersonList = [];
          }
        })
        .catch((err) => {
          this.pushPersonList = [];
        });
    },
    factoryChange() {
      this.formData.workshopId = '';
      this.formData.positiveSceneId = '';
      this.formData.negativeSceneId = '';
      this.getWorkshopByFactory();
    },
    workShopChange() {
      this.formData.positiveSceneId = '';
      this.formData.negativeSceneId = '';
      this.getSceneByWorkshop();
    },
    addPushTimeRange() {
      const key = `pushTime${this.formData.pushTimeRange.length + 1}`;
      this.formData.pushTimeRange.push({
        key: ['00:00', '23:59']
      });
    },
    delPushTimeRange(item, index) {
      if (index === 0) {
        return;
      }
      this.formData.pushTimeRange.splice(index, 1);
    },
    subMit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const timeRanges = this.formData.pushTimeRange
            .map((item) => {
              const timeArray = Object.values(item)[0]; // 获取时间数组
              if (timeArray && timeArray.length === 2) {
                return timeArray.join('-');
              } else {
                return ''; // 或者忽略
              }
            })
            .filter(Boolean); // 过滤掉空字符串
          const pushTimeRangeStrTem = timeRanges.join(','); // 多个时间段用逗号分隔
          const params = {
            factoryId: this.formData.factoryId,
            workshopId: this.formData.workshopId,
            positiveSceneId: this.formData.positiveSceneId,
            negativeSceneId: this.formData.negativeSceneId,
            pressureDiffAlert: this.formData.pressureDiffAlert,
            alarmPushSetting: {
              contactUserIdList: this.formData.contactUserIdList,
              pushTimeRangeStr: pushTimeRangeStrTem
            }
          };

          if (this.id) {
            // 编辑
            this.editForm(params);
          } else {
            this.addForm(params);
          }
        } else {
          return false;
        }
      });
    },
    // 新增表
    addForm(params) {
      request
        .post(`${api.alarmManagement.alarmPressureTxSetting}`, {
          ...params
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('添加成功');
            this.dialogVisible = false;
            this.$emit('refreshTable');
          } else {
            this.$message.error('添加失败');
          }
        })
        .catch((err) => {
          this.$message.error('添加失败');
        });
    },
    // 编辑
    editForm(params) {
      request
        .put(`${api.alarmManagement.alarmPressureTxSetting}`, {
          ...params,
          id: this.id,
          revision: this.revision
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('修改成功');
            this.dialogVisible = false;
            this.$emit('refreshTable');
          } else {
            this.$message.error('修改失败');
          }
        })
        .catch((err) => {
          this.$message.error('修改失败');
        });
    },
    async getDetail() {
      // const rangeTimeList = obj.alarmPushSetting.pushTimeRangeStr.split(',').map((item, index) => {
      //   const key = `pushTime${index + 1}`;
      //   return {
      //     [key]: item.split('-')
      //   };
      // });

      // this.formData = {
      //   factoryId: obj.factoryId,
      //   workshopId: obj.workshopId,
      //   positiveSceneId: obj.positiveSceneId,
      //   negativeSceneId: obj.negativeSceneId,
      //   pressureDiffAlert: obj.pressureDiffAlert,
      //   contactUserIdList: obj.alarmPushSetting.contactUserIdList,
      //   pushTimeRange: rangeTimeList
      // };

      // this.getWorkshopByFactory();
      // this.getSceneByWorkshop();

      request
        .get(`${api.alarmManagement.alarmPressureTxSetting}/${this.id}`)
        .then((res) => {
          if (res.code === 200) {
            if (res.data) {
              const obj = res.data;
              const rangeTimeList = obj.alarmPushSetting.pushTimeRangeStr.split(',').map((item, index) => {
                const key = `pushTime${index + 1}`;
                return {
                  [key]: item.split('-')
                };
              });
              this.formData = {
                factoryId: obj.factoryId,
                workshopId: obj.workshopId,
                positiveSceneId: obj.positiveSceneId,
                negativeSceneId: obj.negativeSceneId,
                pressureDiffAlert: obj.pressureDiffAlert,
                contactUserIdList: obj.alarmPushSetting.contactUserIdList,
                pushTimeRange: rangeTimeList
              };
              this.revision = obj.revision;
              this.getWorkshopByFactory();
              this.getSceneByWorkshop();
            }
          } else {
            this.$message.error('获取详情失败');
          }
        })
        .catch((err) => {
          this.$message.error('获取详情失败');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  .el-dialog__header {
    padding: 20px;
  }

  .el-dialog__body {
    padding: 0 20px;

    .el-form {
      padding: 0;
      display: flex;
      flex-wrap: wrap;

      .el-form-item {
        width: 100%;

        .el-form-item__label {
          text-align: left;
        }

        .el-form-item__content {
          width: calc(100% - 130px);

          .el-select {
            width: 100%;
          }

          .el-input-number {
            width: 100%;
            line-height: 32px;
          }
          .el-input-number.is-controls-right .el-input-number__decrease,
          .el-input-number.is-controls-right .el-input-number__increase {
            line-height: 15px;
          }

          .range-time-box {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 10px;
            .el-range-editor {
              width: calc(100% - 20px);
            }

            .el-icon-delete {
              margin-left: 4px;
              font-size: 16px;
              cursor: pointer;
              &:hover {
                color: #366bfc;
              }

              &.fist-time-picker-del-but {
                cursor: not-allowed;
                color: #c1c1c1;
              }
            }
          }

          .add-content-box {
            color: #366bfc;
          }

          .el-icon-circle-plus-outline {
            font-size: 16px;
            cursor: pointer;
            margin-right: 4px;
            &:hover {
              color: #366bfc;
            }
          }
        }
      }
    }

    .sub-title {
      margin-bottom: 20px;
    }
  }
}
</style>
